const Action = require("components/abstract/Action");

class Tab extends Action {

    _onAction = () => {
		return this.onAction(this.props.value);
    }

    render(){
        return(
            <li className={this.props.className} onClick={this._onAction}>{this.props.children}</li>  
        );
    }

}

module.exports = Tab;
